var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotsActionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 24,
    viewBox: "0 0 8 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3623 20.628C1.3623 21.3242 1.63887 21.9919 2.13115 22.4841C2.62343 22.9764 3.29111 23.253 3.9873 23.253C4.6835 23.253 5.35118 22.9764 5.84346 22.4841C6.33574 21.9919 6.6123 21.3242 6.6123 20.628C6.6123 19.9318 6.33574 19.2641 5.84346 18.7718C5.35118 18.2796 4.6835 18.003 3.9873 18.003C3.29111 18.003 2.62343 18.2796 2.13115 18.7718C1.63887 19.2641 1.3623 19.9318 1.3623 20.628Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3623 3.37799C1.3623 4.07418 1.63887 4.74186 2.13115 5.23415C2.62343 5.72643 3.29111 6.00299 3.9873 6.00299C4.6835 6.00299 5.35118 5.72643 5.84346 5.23415C6.33574 4.74186 6.6123 4.07418 6.6123 3.37799C6.6123 2.6818 6.33574 2.01412 5.84346 1.52184C5.35118 1.02955 4.6835 0.752991 3.9873 0.752991C3.29111 0.752991 2.62343 1.02955 2.13115 1.52184C1.63887 2.01412 1.3623 2.6818 1.3623 3.37799Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3623 12.003C1.3623 12.6992 1.63887 13.3669 2.13115 13.8591C2.62343 14.3514 3.29111 14.628 3.9873 14.628C4.6835 14.628 5.35118 14.3514 5.84346 13.8591C6.33574 13.3669 6.6123 12.6992 6.6123 12.003C6.6123 11.3068 6.33574 10.6391 5.84346 10.1468C5.35118 9.65455 4.6835 9.37799 3.9873 9.37799C3.29111 9.37799 2.62343 9.65455 2.13115 10.1468C1.63887 10.6391 1.3623 11.3068 1.3623 12.003Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsActionIcon);
export default __webpack_public_path__ + "static/media/three-dots-action-icon.18b629659a2638cb2fa7d1d99e5c3068.svg";
export { ForwardRef as ReactComponent };